import axios from 'axios';

const API_BASE_URL = process.env.REACT_APP_API_URL || 'http://localhost:8000';

const api = axios.create({
  baseURL: API_BASE_URL,
  timeout: 10000,
});

export const articleService = {
  // Get articles with pagination
  getArticles: (page = 1, size = 20, category = null) => {
    let url = `/articles/?page=${page}&size=${size}`;
    if (category) url += `&category=${category}`;
    return api.get(url);
  },
  
  // Get featured articles
  getFeatured: (limit = 5) => api.get(`/articles/featured?limit=${limit}`),
  
  // Get trending articles
  getTrending: (limit = 10) => api.get(`/articles/trending?limit=${limit}`),
  
  // Get single article
  getArticle: (id) => api.get(`/articles/${id}`),
  
  // Get articles by category
  getByCategory: (category, limit = 10) => 
    api.get(`/articles/by-category/${category}?limit=${limit}`),
  
  // Increment view count
  incrementView: (id) => api.post(`/articles/${id}/view`),
};

export const categoryService = {
  getAll: () => api.get('/categories/'),
  getArticles: (slug, limit = 20) => api.get(`/categories/${slug}/articles?limit=${limit}`),
};

export default api;